import { render, staticRenderFns } from "./IndexR6.vue?vue&type=template&id=f870d368&scoped=true&"
import script from "./IndexR6.vue?vue&type=script&lang=js&"
export * from "./IndexR6.vue?vue&type=script&lang=js&"
import style0 from "./IndexR6.vue?vue&type=style&index=0&id=f870d368&lang=scss&scoped=true&"
import style1 from "./IndexR6.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f870d368",
  null
  
)

export default component.exports